define('fukit/behavior/navigate.on.create.event.behavior',['require','exports','module','underscore','backbone','marionette','../helpers/route.helper','appkit/util/key.prefixer','backbone.radio','./navigate.on.event.behavior'],function(require, exports, module) {
  //prettier-ignore
  var _                       = require('underscore'),
      Backbone                = require('backbone'),
      Mn                      = require('marionette'),
      RouteHelper             = require('../helpers/route.helper'),
      KeyPrefixer             = require('appkit/util/key.prefixer'),
      Radio                   = require('backbone.radio'),
      NavigateOnEventBehavior = require('./navigate.on.event.behavior');

  var NavigateOnCreateEventBehavior = NavigateOnEventBehavior.extend({
    onFirstRender: function() {
      this.model = this.getOption('model') || this.view.model;

      if (this.model.isNew()) {
        this.setupSyncListener();
      }
    },

    onEvent: function() {},

    setupSyncListener: function() {
      this.listenToOnce(this.model, 'sync', function() {
        this.navigate();
      });
    },
  });

  module.exports = NavigateOnCreateEventBehavior;
});

